import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Text } from '../../../text';

const aiActivityBubbleDivStyle2 = css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1)};
  position: relative;
`;

const aiActivityBubbleTextStyle3 = css`
  word-break: break-word;
`;

type AiActivityBubbleProps = {
  text: ReactNode;
  leadingIcon?: ReactNode;
};
export const AiActivityBubble = ({ text, leadingIcon }: AiActivityBubbleProps) => {
  return (
    <div className={cx('bubble-content', aiActivityBubbleDivStyle2, !!leadingIcon && leadingLineStyles)}>
      {leadingIcon}
      <Text size='small' className={cx(aiActivityBubbleTextStyle3, 'bubble-text')} color='default'>
        {text}
      </Text>
    </div>
  );
};

const leadingLineStyles = css`
  &::before {
    content: '';
    position: absolute;
    left: -${theme.spacing(1)};
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: ${theme.spacing(1.5)};
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.large};
  }
`;
